(function() {
  var addToCartBtns = document.querySelectorAll('.custom-quick-add');

  addToCartBtns.forEach(function(addToCartBtn) {
    addAddToCartEventListener(addToCartBtn);
  });

  function addAddToCartEventListener(btn) {
    var variantInputs = btn.closest('form').querySelectorAll('input[name="id"]');

    variantInputs.forEach(function(variantInput) {
      variantInput.addEventListener('click', function(event) {
 if (this.closest('label').classList.contains('unavailable')) {
        return; // Exit the function if the variant is unavailable
      }

      var variantId = event.target.value;
      var quantity = parseInt(event.target.dataset.quantity);
      var data = {
        id: variantId,
        quantity: quantity
      };

      // Check the current quantity of the variant in the cart
      var currentQuantity = 0;
      var cartItems = JSON.parse(localStorage.getItem('cart'));
      if (cartItems) {
        cartItems.forEach(function(item) {
          if (item.variant_id == variantId) {
            currentQuantity += item.quantity;
          }
        });
      }

      // Check if the selected quantity exceeds the available stock
      var availableStock = parseInt(this.closest('label').dataset.availability);
      var selectedQuantity = currentQuantity + quantity;
      if (selectedQuantity > availableStock) {
        // Display an error message for 2 seconds
        errorDiv.textContent = 'Sorry, only ' + (availableStock - currentQuantity) + ' items are available for this variant.';
        setTimeout(function() {
          errorDiv.textContent = '';
        }, 2000);
        return; // Exit the function
      }
        // Trigger the cart update functionality
        document.dispatchEvent(
          new CustomEvent("theme:cart:add", {
            bubbles: !0,
            detail: {
              element: btn,
              label: "quick",
              button: btn,
              data: data,
            },
          })
        );
      });
    });
  }
})();

document.addEventListener('theme:variant:change', function(evt) {
console.log(evt.detail.variant);
  var varQty = evt.detail.variant.inventory_quantity;
  var varPolicy = evt.detail.variant.inventory_policy;
  
 
  if (varQty > 0 ){
    $('.btn__text[data-add-to-cart-text]').text('Add to Cart');
    $('.potxt').attr('style','display:none;');
  } else {
     if(varPolicy == "continue"){
    $('.btn__text[data-add-to-cart-text]').text('Pre-order');
    $('.potxt').removeAttr('style');
     }
  }
  
});